import React from 'react'
import MaterialIcon from 'material-icons-react'

const bluredImage = 'https://image.freepik.com/free-vector/white-blurred-background_1034-249.jpg'

export default class Imagem extends React.Component{

    state = {
        isEditing : false,
        isBig : false,
        realW : null,
        realH : null
    }

    toggleEdition = () => {
        this.setState({isEditing : !this.state.isEditing})
        console.log('toggleEdition = () =>',this.state);
    }

    editHandlerLocal = () =>{
        this.setState({isEditing : false})
        this.props.editar()
    }

    

    showBig = () =>{
        //todo
    }

    render(){
        let {src, desc, deletar, onChange} = this.props;
        let descComp = this.state.isEditing? <input type='text' onKeyUp={(e)=>e.keyCode==13?this.editHandlerLocal():null} className='imagem_show_desc' onChange={onChange} defaultValue={desc}/> : <span className='imagem_show_desc'>{desc}</span>
        let styleDir = {backgroundImage:'url("'+src+'"), url("'+bluredImage+'")'}
        return(
            <div className="imagem_show"  onClick={this.showBig} style={styleDir} ikey={Date.now()}>
                {descComp}
                <div className='button'>
                    <div className="b delete" onClick={this.state.isEditing? this.editHandlerLocal : this.toggleEdition}>
                        <MaterialIcon   icon={this.state.isEditing?'save':"border_color"} size={20}/>
                    </div>
                    <div className="b delete" onClick={deletar}>
                        <MaterialIcon   icon="delete_forever" size={20}/>
                    </div>
                </div>                    
                <div className='bottom_cover'/>
            </div>
        )
    }
}
    


// WEBPACK FOOTER //
// ./src/views/administrativo/imagens/imagem.js